export default {
  'default': {
    'title': 'Erreur',
    'message': 'Une erreur s\'est produite'
  },
  '6': {
    'message': 'Mauvaise combinaison email / mot de passe'
  },
  '10': {
    'message': 'Formulaire incomplet'
  },
  '21': {
    'message': 'Votre lien de réinitialisation de mot de passe a expiré'
  },
  '22': {
    'message': 'L\'utilisateur existe déjà'
  },
  '25': {
    'message': 'L\'utilisateur n\'existe pas'
  },
  '29': {
    'message': 'Le mot de passe doit contenir au moins 8 caractères.'
  },
  '43': {
    'message': 'Le nom de la campagne est déjà utilisé. Veuillez utilisez un autre nom pour la campagne.'
  },
  '146': {
    'message': 'La librairie ne peut être supprimer car elle contient des médias.'
  },
  '701': {
    'message': 'Un challenge est déjà programmé sur cette période.'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/api.js